
        <span #react></span>
        <template #template>
            <span>
                <ng-content></ng-content>
            </span>
        </template>